<template>
  <div class="qikan-container">
    <custom-router-link :item="info" class="qikan-link" :to="{name: 'HomeDetails', params: {id: info.id}}" target="_blank">
      <div class="qikan-title">
        {{info.name}}
      </div>
      <i class="el-icon-arrow-right"></i>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.qikan-container {
  width: 100%;
  height: 100%;
  .qikan-link {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f8f9fa;
    padding: 30px 20px;
    margin-top: 20px;
    .qikan-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #212529;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}
</style>